import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);


/**
 * TextAnimations
 *
 * @class
 * @classdesc TextAnimations
 */
export class TextAnimations {
    /**
     * Constructor
     *
     * @param {Object[]} selectors - Tableau d'objets définissant les sélections DOM.
     * @param {string} selectors[].selector - Le sélecteur CSS pour la sélection.
     * @param {"lines"|"words"} selectors[].type - Le type de traitement associé au sélecteur.
     * @param {string} selectors[].position - Position de l'animation dans la timeline.
     * @param {string} trigger - Le sélecteur CSS pour le déclencheur.
     * @param {Object} options - Les options de la timeline.
     * @param {Object} scrollTriggerOptions - Les options de ScrollTrigger.
     */
    constructor(selectors, trigger, options = {}, scrollTriggerOptions= {}) {
        this.selector = selectors;
        this.trigger = trigger;
        this.options = options;
        this.scrollTriggerOptions = scrollTriggerOptions;
    }

    init() {
        this.timeLine = gsap.timeline({
            scrollTrigger: {
                trigger: this.trigger,
                ...this.scrollTriggerOptions
            }, ...this.options
        });
    }

    animate() {
        this.selector.forEach(({selector, type, position = "<"}) => {
            // vérifier si le selector est une chaîne de caractères
            if (typeof selector == 'string') {
                if (document.querySelectorAll(selector)?.length > 0) {
                    document.querySelectorAll(selector).forEach((el) => {
                        el.classList.add('timeline-text-reveal');
                        if(type === 'lines') {
                            el.classList.add('timeline-text-reveal--lines');
                        }
                    })
                } else {
                    return;
                }
            } else if(selector?.length > 0) {
                selector.forEach((el) => {
                    el.classList.add('timeline-text-reveal');
                    if(type === 'lines') {
                        el.classList.add('timeline-text-reveal--lines');
                    }
                });
            } else {
                selector?.classList.add('timeline-text-reveal');
                if(type === 'lines') {
                    selector?.classList.add('timeline-text-reveal--lines');
                }
            }

            const splitText = new SplitText(selector, type === 'lines' ? {
                type: 'lines',
                linesClass: 'line'
            } : {type: 'words'});

            console.log('split text', splitText);

            this.timeLine.from(
                splitText[type],
                {
                    y: '100%',
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                    stagger: 0.1
                },
                position
            );
        });
    }
}